import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=3c2fc250&scoped=true&"
import script from "./RuleActions.vue?vue&type=script&lang=ts&"
export * from "./RuleActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2fc250",
  null
  
)

export default component.exports